import React from 'react';
import {Container, Row, Col, Figure} from 'react-bootstrap';
import './Home.css';

const  Awards = () => {
    return ( 
        <Container>
  <Row>
    <Col xs={12} md={12}>
    <Figure className="itemsimg">
    <Figure.Caption>
  <p><h2><span className="fontcolor">Best SME Organisation of the Year-2009</span></h2></p>
            <p><h4></h4></p>
  </Figure.Caption>
  <Figure.Image
    width={850}
    height={850}
    alt="171x180"
    src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596769/nonedb/Award_1_iwvw2a.jpg"
  />
  <Figure.Caption>
    
  </Figure.Caption>
</Figure>  
      
    </Col>
  </Row>
  <Row>
    <Col xs={12} md={12}>
    
    <Figure className="itemsimg">
    <Figure.Caption>
  <p><h2><span className="fontcolor">Nominated -Top 15 African Companies</span></h2></p>
            <p><h4></h4></p>
  </Figure.Caption>
  <Figure.Image
    width={850}
    height={850}
    alt="171x180"
    src="https://res.cloudinary.com/dr0cgsqke/image/upload/v1611596769/nonedb/Award_2_m3w6rs.jpg"
  />
  <Figure.Caption>
    
  </Figure.Caption>
</Figure>  
    </Col>
  </Row>
</Container>)
};
 
export default Awards ;